import type {} from 'pinia-plugin-persistedstate'
import { createPersistedState } from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin(({ $pinia }) => {
  ($pinia as any).use(createPersistedState({
    storage: localStorage,
  }))
})
